<app-widget-option [categories]="['LAYERS']" [label]="'MIN'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-number [value]="widgetLayers.layer(current).gaugeMin" (sendValue)="receiveValue($event)" [color]="color" [step]="20"></app-number>
  </div>
</app-widget-option>